import { GetServerSideProps, NextPage } from 'next';
import styled from '@emotion/styled';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

// components
import DefaultLayout from '@components/_templates/DefaultLayout';
import MainSection from '@components/_templates/IntroSection/MainSection';
import Section0 from '@components/_templates/IntroSection/Section0';
import Section1 from '@components/_templates/IntroSection/Section1';
import Section2 from '@components/_templates/IntroSection/Section2';
import Section3 from '@components/_templates/IntroSection/Section3';

// constants
import { MOBILE_MODE, TABLET_MODE } from '@constants/size';
import { gray } from '@styles/Colors';
import { useTranslation } from 'next-i18next';
import { COMPANY_IR_EN, COMPANY_IR_KO, COMPANY_IR_PH } from '@constants/routes/routes';
import DefaultSEO from '@components/_organism/DefaultSEO';
import { isPhDomain } from '@utils/domain';

type Props = {
  readonly isPh: boolean;
};

const Section = styled.section<{ backgroundGray?: boolean }>`
  padding: 160px 0;
  position: relative;

  @media ${TABLET_MODE} {
    padding: 120px 0;
  }

  @media ${MOBILE_MODE} {
    padding: 80px 0;
  }

  ${({ backgroundGray }) =>
    backgroundGray &&
    `
   background: ${gray.gray1};
  `}
`;

const Intro: NextPage<Props> = ({ isPh }) => {
  const { t, i18n } = useTranslation('intro');
  const ko = i18n.language === 'ko';

  const COMPANY_IR = isPh ? COMPANY_IR_PH : ko ? COMPANY_IR_KO : COMPANY_IR_EN;

  return (
    <>
      <DefaultSEO title={t('meta-title')} description={t('meta-description')} />
      <DefaultLayout>
        {/* Main Section */}
        <MainSection fileUrl={COMPANY_IR} />
        {/* Main Section end */}

        {/* 회사 미션 Section */}
        <Section backgroundGray>
          <Section0 />
        </Section>
        {/* 회사 미션 Section end */}

        {/* 회사 히스토리 Section (steelboso.ph 미노출) */}
        {!isPh && (
          <Section>
            <Section1 />
          </Section>
        )}
        {/* 회사 히스토리 Section end */}

        {/* 회사 위치 Section */}
        <Section>
          <Section2 isPh={isPh} />
        </Section>
        {/* 회사 위치 Section end */}

        {/* 회사소개 다운로드 Section */}
        <Section3 fileUrl={COMPANY_IR} />
        {/* 회사소개 다운로드 Section end */}
      </DefaultLayout>
    </>
  );
};

export const getServerSideProps: GetServerSideProps<Props> = async ({ locale, req }) => ({
  props: {
    isPh: isPhDomain(req.headers.host),
    ...(await serverSideTranslations(locale as string, ['intro', 'home', 'common'])),
  },
});

export default Intro;
